import React from 'react';
import { Loader2, ShieldCheck, Smartphone } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import CodeInput from '@/components/twofactor/CodeInput';

export default function EnrollForm({ enroll, code, onCodeChange, submitting, onSubmit, onCancel }) {
  return (
    <form onSubmit={onSubmit} className="space-y-4" data-testid="totp-enroll-form">
      {enroll?.qr_code_data_url && (
        <div className="flex justify-center">
          <img src={enroll.qr_code_data_url} alt="Google Authenticator QR code" className="h-44 w-44 rounded-lg bg-white p-2" data-testid="totp-qr-code" />
        </div>
      )}
      <div className="rounded-lg border border-slate-700 bg-slate-950 p-3 text-center">
        <p className="text-xs text-slate-400 flex items-center justify-center gap-1"><Smartphone className="h-3.5 w-3.5" /> Can&apos;t scan? Enter this key manually:</p>
        <code className="mt-1 block break-all font-mono text-sm text-slate-200" data-testid="totp-manual-key">{enroll?.manual_entry_key}</code>
      </div>
      <div className="space-y-2">
        <Label className="text-slate-300">Verification code</Label>
        <CodeInput code={code} onChange={onCodeChange} />
      </div>
      <Button type="submit" className="w-full bg-indigo-600 hover:bg-indigo-500" disabled={submitting || code.length !== 6} data-testid="totp-enroll-submit">
        {submitting ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <ShieldCheck className="mr-2 h-4 w-4" />}
        Verify &amp; enable
      </Button>
      {onCancel && (
        <button type="button" onClick={onCancel} className="w-full text-center text-sm text-slate-400 hover:text-slate-200" data-testid="totp-enroll-cancel">
          Not now — go back
        </button>
      )}
    </form>
  );
}
